var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lumiere-video-features-zone",class:{
    'show-features': _vm.showFeatures,
  },style:(_vm._f("px")(_vm.style))},[_vm._t("default",null,{"featuresZone":_vm.featuresZone})],2)}
var staticRenderFns = []

export { render, staticRenderFns }